import uuid from 'uuid/v1';
import {normalize} from "normalizr";

import api from "./api";
import {notification} from './store/schema'
import * as selectors from './application.selectors';
import {removeToken, decodeToken} from './token_management'

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const PAGE_TITLE_SET = 'PAGE_TITLE_SET';
export const FETCHING_NAVIGATION = 'FETCHING_NAVIGATION';
export const NAVIGATION_RETRIEVED = 'NAVIGATION_RETRIEVED';
export const FACILITIES_RETRIEVED = 'FACILITIES_RETRIEVED';
export const REVIEWERS_RETRIEVED = 'REVIEWERS_RETRIEVED';
export const MQDS_RETRIEVED = 'MQDS_RETRIEVED';
export const EPASRR_URL_SET = 'EPASRR_URL_SET';
export const FETCHING_DATA = 'FETCHING_DATA';
export const DATA_FETCHED = 'DATA_FETCHED';
export const USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED';

export const NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED';
export const NOTIFICATION_DISMISSED = 'NOTIFICATION_DISMISSED';

export const BREADCRUMBS_SET = 'BREADCRUMBS_SET';
export const setBreadcrumbs = crumbs => ({
  type: BREADCRUMBS_SET,
  payload: crumbs.map(x => ({...x, id: uuid()}))
});

export const fetchingData = {type: FETCHING_DATA};
export const fetchingDone = ({type: DATA_FETCHED});

export const unauthorized = () => (dispatch, getState) => {
  setTimeout(() => window.location = selectors.epasrrUrl(getState()), 3000);
  dispatch(sendWarning("Your session has expired. You will be redirected to login again."));
};

export const logUserIn = () => {
  const decoded = decodeToken();
  console.log('token', decoded)
  const {unique_name, email, role, nameid} = decoded;
  return ({
    type: USER_LOGGED_IN,
    payload: {
      email,
      roles: Array.from(new Set(role.filter(x => x.startsWith('ePASRR')))),
      name: unique_name.sort()[0],
      id: nameid.replace(/-/g, '')
    }
  });
};
export const logUserOut = (e) => (dispatch, getState) => {
  e.preventDefault();
  const epasrrUrl = selectors.epasrrUrl(getState());
  removeToken();
  dispatch(({
    type: USER_LOGGED_OUT,
  }));
  window.location = `${epasrrUrl}/account/logout`
};

export const getEpasrrUrl = () => async (dispatch) => {
  await api(dispatch).get('epasrr/config', data => [
    {type: EPASRR_URL_SET, suppressActionTracking: true, payload: data.url}
  ]);
};

export const setPageTitle = (title, subTitle) => ({
  type: PAGE_TITLE_SET,
  payload: {title, subTitle}
});

export const raiseError = message => ({
  type: NOTIFICATION_RECEIVED,
  payload: normalize({
    id: uuid(),
    type: 'error',
    message: Array.isArray(message) ? message : [message]
  }, notification)
});

export const sendNotification = message => ({
  type: NOTIFICATION_RECEIVED,
  payload: normalize({id: uuid(), type: 'success', message}, notification)
});
export const sendWarning = message => ({
  type: NOTIFICATION_RECEIVED,
  payload: normalize({id: uuid(), type: 'warning', message}, notification)
});
export const dismissNotification = id => ({
  type: NOTIFICATION_DISMISSED,
  payload: id
});

export const fetchFacilities = () => async (dispatch, getState, {schema}) => {
  await api(dispatch).get('epasrr/facilities', data => ({
    type: FACILITIES_RETRIEVED,
    payload: {
      ...normalize(data.facilities, [schema.facility]),
      userFacility: data.userFacility
    }
  }));
};

export const fetchReviewers = () => async (dispatch, getState, {schema}) => {
  await api(dispatch).get('epasrr/reviewers', data => ({
    type: REVIEWERS_RETRIEVED,
    payload: normalize(data, [schema.reviewer])
  }));
};

export const fetchMQDs = () => async (dispatch, getState, {schema}) => {
  await api(dispatch).get('epasrr/users-by-role?role=ePASRR_MQD', data => ({
    type: MQDS_RETRIEVED,
    payload: normalize(data, [schema.MQD])
  }));
};

export const fetchNavigation = () => async (dispatch) => {
  dispatch({type: FETCHING_NAVIGATION,});
  await api(dispatch).get('epasrr/navigation', data => (
    {type: NAVIGATION_RETRIEVED, suppressActionTracking: true, payload: data})
  );
};


// WEBPACK FOOTER //
// ./src/application.actions.js